import _ from 'underscore';
import localeConfig from 'text!app-locale';

var nameConfig = JSON.parse(localeConfig).name;

function _append(sb, fieldId, value) {
    if (!_.isEmpty(value) && _.contains(nameConfig.visibleFields, fieldId)) {
        sb.push(value);
    }
}

function _format(person, delimiter) {
    var lastName = person.lastNameKanji || person.lastName;
    var firstName = person.firstNameKanji || person.firstName;
    var result = [];
    switch (nameConfig.formatMode) {
        case 'default':
            _append(result, 'FirstName', firstName);
            _append(result, 'LastName', lastName);
            break;
        case 'France':
            _append(result, 'LastName', lastName);
            _append(result, 'FirstName', firstName);
            break;
        case 'Japan':
            _append(result, 'LastName', lastName);
            _append(result, 'FirstName', firstName);
            break;
        case 'China':
            _append(result, 'LastName', lastName);
            _append(result, 'FirstName', firstName);
            break;
        default:
            break;
    }
    return result.join(delimiter);
}

function Person(data) {
    this.getDisplayName = function (defaultName, $filter) {
        return _format(this, ' ') || defaultName || $filter('translate')('quoteandbind.controllers.this driver');
    };

    if (data) {
        _.extend(this, data);
        if (!data.firstName) {
            data.firstName = '';
        }
        if (!data.lastName) {
            data.lastName = '';
        }
    }
}

export default Person;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/common/models/Person.js
// module id = 297
// module chunks = 0